import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../BaseUrl";

const initialState = {
    loading: false,
    preApprovedTeamMembers: [],
    error: ''
}

const url = `${BASE_URL}/worker`

const token = localStorage.getItem("token")

const config = {
    headers: {
        Authorization: `Token ${token}`,
    }
}


export const fetchPreApprovedTeamMembers = createAsyncThunk(
    'fetch/preApprovedTeamMembers', async () => {
        return axios
        .get(`${url}/preapprove/`, config)
        .then((response) => response.data)
    }
)


const preApprovedTeamMembersSlice = createSlice({
    name: "preApprovedTeamMembers",
    initialState,
    extraReducers: (builder) => {
      builder.addCase(fetchPreApprovedTeamMembers.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(fetchPreApprovedTeamMembers.fulfilled, (state, action) => {
        state.loading = false;
        state.preApprovedTeamMembers = action.payload;
        state.error = "";
      });
      builder.addCase(fetchPreApprovedTeamMembers.rejected, (state, action) => {
        state.loading = false;
        state.preApprovedTeamMembers = [];
        state.error = action.error;
      });
    },
  });


  export default preApprovedTeamMembersSlice.reducer